import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import { images } from '../data/images';
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section id="top" aria-labelledby="hero-title" className="relative flex h-[110vh] max-h-none min-h-[650px] items-center overflow-visible bg-ink" data-id="element-179" data-mp="9lv0spiridvb">
      <img src={images.hero} alt={t.hero.imageAlt} fetchPriority="high" className="absolute h-full w-full object-cover object-center" data-id="element-180" data-mp="1297ahz3tqr77" />
      <div aria-hidden="true" className="absolute inset-0 bg-violet-deep/5" data-id="element-181" data-mp="x8jmlmaw6qh7" />
      <div aria-hidden="true" className="absolute inset-0 bg-ink/20" data-id="element-182" data-mp="s9qa9x7cd5im" />

      <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="relative mx-auto w-full max-w-7xl px-6 pb-16 md:px-10 md:pb-24 min-h-[700px] md:min-h-screen" data-id="element-183" data-mp="nb6ktmtjhbli">
        <p className="font-serif text-[18px] italic text-white/90 md:text-[20px]" data-id="element-184" data-mp="3j7zhzqi0g6kd">
          {t.hero.tagline}
        </p>
        <h1 id="hero-title" className="mt-4 max-w-3xl font-display text-[38px] font-medium leading-[1.12] tracking-[-0.015em] text-white md:text-[56px]" data-id="element-185" data-mp="3o6ap3tgx82yw">
          {t.hero.h1}
          <span className="sr-only" data-id="element-186" data-mp="3e84mf9naissz"> | Alma Yoga NYC</span>
        </h1>
        <p className="mt-6 text-[17px] font-medium tracking-[0.02em] text-white md:text-[19px]" data-id="element-187" data-mp="30hhsrvwdzt3r">
          {t.hero.sub}
        </p>
        <p className="mt-4 max-w-xl text-[16px] leading-[1.8] text-white/85 md:text-[17px]" data-id="element-188" data-mp="35aausc0h0nc5">
          {t.hero.description}
        </p>
        <div className="mt-10 flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4" data-id="element-189" data-mp="2qi0nvgoylj8u">
          <a href="#contact" className="btn btn-primary" data-id="element-190" data-mp="2vglmjbokbuv6">
            {t.hero.cta}
          </a>
          <a href="#services" className="btn btn-ghost-light" data-id="element-191" data-mp="2hl9puyqujubm">
            {t.hero.secondary}
          </a>
        </div>
      </motion.div>
    </section>;
}